const BUTTON_AUTH = ['07070001', '07070002', '07070003'];

export default {
    configuration: true,
    'buttonList': [
        {
            'type': 'text',
            'icon': 'el-icon-money',
            'label': '智汇票登录',
            'loading': false,
            'size': 'small',
            'event': 'invoiceRegistration',
            'ifHas': BUTTON_AUTH[0]
        },
        {
            'type': 'text',
            'icon': 'el-icon-search',
            'label': '查询',
            'size': 'small',
            'event': 'search'
        },
        {
            'type': 'text',
            'icon': 'el-icon-circle-check',
            'label': '启用',
            'size': 'small',
            'event': 'start',
            'ifHas': BUTTON_AUTH[1]
        },
        {
            'type': 'text',
            'icon': 'el-icon-circle-close',
            'label': '停用',
            'size': 'small',
            'event': 'stop',
            'ifHas': BUTTON_AUTH[2]
        }
    ],
    'table': {
        'switchType': true,
        'tableCut': false,
        'clickState': false,
        'selectBtn': true,
        'isPagination': false,
        'height': 'calc(100vh - 180px)',
        'columns': [
            {
                'label': '供应商名称',
                'prop': 'supplierName',
                'width': '120px'
            },
            {
                'label': '纳税人识别号',
                'prop': 'taxNo',
                'width': '180px'
            },
            {
                'label': '开票人',
                'prop': 'invoiceBy',
                'width': '150px'
            },
            {
                'label': '生效日期',
                'prop': 'effectiveDate',
                'width': '150px'
            },
            {
                'label': '失效日期',
                'prop': 'expirationDate',
                'width': '150px'
            },
            {
                'label': '已维护销方信息',
                'prop': 'isMaintained',
                'type': 'select',
                'options': [
                    {
                        'label': '是',
                        'value': 1
                    },
                    {
                        'label': '否',
                        'value': 0
                    }
                ],
                'width': '150px'
            },
            {
                'label': '销售方地址',
                'prop': 'sellerAddress',
                'width': '150px'
            },
            {
                'label': '销售方电话',
                'prop': 'sellerPhone',
                'width': '150px'
            },
            {
                'label': '销售方开户行',
                'prop': 'sellerOpeningBank',
                'width': '150px'
            },
            {
                'label': '销售方银行账号',
                'prop': 'sellerBankAccount',
                'width': '150px'
            },
            {
                'label': '状态',
                'prop': 'status',
                'type': 'select',
                'options': [
                    {
                        'label': '启用',
                        'value': 1
                    },
                    {
                        'label': '停用',
                        'value': 0
                    }
                ],
                'width': '150px'
            },
            {
                'label': '创建时间',
                'prop': 'createTime',
                'width': '150px'
            },
            {
                'label': '创建人',
                'prop': 'creator',
                'width': '150px'
            }
        ]
    },
    'page': {
        'layout': 'total, sizes, prev, pager, next, jumper',
        'pageSize': 10
    }
};